import { render, staticRenderFns } from "./IbJobLookup.vue?vue&type=template&id=2a17a9a7&scoped=true"
import script from "./IbJobLookup.vue?vue&type=script&lang=js"
export * from "./IbJobLookup.vue?vue&type=script&lang=js"
import style0 from "./IbJobLookup.vue?vue&type=style&index=0&id=2a17a9a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a17a9a7",
  null
  
)

export default component.exports